import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { IRecurringOrderService } from '../entities/IRecurringOrderService';
import { IRecurringOrderRepository } from '../entities/IRecurringOrderRepository';
import { StandingOrder, SweepOrder, StandingOrderDetails, SweepOrderDetails } from '../entities';

export class RecurringOrderServiceImpl implements IRecurringOrderService {
  itemRepo: IRecurringOrderRepository;

  constructor(ir: IRecurringOrderRepository) {
    this.itemRepo = ir;

    this.GetStandingOrders = this.GetStandingOrders.bind(this);
    this.GetSweepOrders = this.GetSweepOrders.bind(this);
    this.GetStandingOrderDetails = this.GetStandingOrderDetails.bind(this);
    this.GetSweepOrderDetails = this.GetSweepOrderDetails.bind(this);
    this.CancelStandingOrder = this.CancelStandingOrder.bind(this);
    this.CancelSweepOrder = this.CancelSweepOrder.bind(this);
  }

  GetStandingOrders(): Promise<StandingOrder[]> {
    return this.itemRepo.GetStandingOrders();
  }

  GetSweepOrders(): Promise<SweepOrder[]> {
    return this.itemRepo.GetSweepOrders();
  }

  GetStandingOrderDetails(data: { id: number }): Promise<StandingOrderDetails> {
    return this.itemRepo.GetStandingOrderDetails(data.id);
  }

  GetSweepOrderDetails(data: { id: number }): Promise<SweepOrderDetails> {
    return this.itemRepo.GetSweepOrderDetails(data.id);
  }

  CancelStandingOrder(data: { id: number; successCallback: SuccessCallback }): Promise<{}> {
    return this.itemRepo.CancelStandingOrder(data.id, data.successCallback);
  }

  CancelSweepOrder(data: { id: number; successCallback: SuccessCallback }): Promise<{}> {
    return this.itemRepo.CancelSweepOrder(data.id, data.successCallback);
  }
}
